const getDefaultState = () => {
    return {
        TEXT_LINE_L : "",
        TEXT_LINE_LD : "",
        TEXT_LINE_A  : "",
        TEXT_LINE_K: "",
        PURCH_NO_C : "",
        changedPrice : 0,
        incoterm : "",
        deliveryAddress: "",
        paymentTerm : "",
        land: '',
        zone: '',
        freight: '',
        customer: '',
        accessories: [],
        customers: []
    }
};

const state = getDefaultState();

const getters = {
    getTextLineL:(s:any) => s.TEXT_LINE_L,
    getTextLineLD:(s:any) => s.TEXT_LINE_LD,
    getTextLineA:(s:any) => s.TEXT_LINE_A,
    getTextLineK: (s: any) => s.TEXT_LINE_K,
    getPurchNoC: (s: any) => s.PURCH_NO_C,
    getChangedPrice : (s:any) => s.changedPrice,
    getIncoterm:(s:any) => s.incoterm,
    getDeliveryAddress:(s:any) => s.deliveryAddress,
    getPaymentTerm:(s:any) => s.paymentTerm,
    getLand: (s:any) => s.land,
    getZone: (s:any) => s.zone,
    getFreight: (s:any) => s.freight,
    getCustomer: (s:any) => s.customer,
    getCustomers: (s: any) => s.customers,
    getAccessories: (s: any) => s.accessories,
    getAllState: (s:any) => s
}

const actions = {
    setTextLineL(context: any, payload:any){
        context.commit('setTextLineL', payload);
    },
    setTextLineLD(context: any, payload:any){
        context.commit('setTextLineLD', payload);
    },
    setTextLineA(context: any, payload:any){
        context.commit('setTextLineA', payload);
    },
    setTextLineK(context: any, payload:any){
        context.commit('setTextLineK', payload);
    },
    setPurchNoC(context: any, payload: any) {
        context.commit('setPurchNoC', payload);
    },
    setIncoterm(context: any, payload:any){
        
        context.commit('setIncoterm', payload.incotermCode);
    },
    setDeliveryAddress(context: any, payload:any){
        context.commit('setDeliveryAddress', payload);
    },
    setPaymentTerm(context: any, payload:any){
        context.commit('setPaymentTerm', payload.paymentTermCode);
    },
    setLand(context: any, payload: any){
        context.commit('setLand', payload)
    },
    setZone(context: any, payload: any){
        context.commit('setZone', payload)
    },
    setFreight(context: any, payload: any){
        context.commit('setFreight', payload)
    },
    setCustomer(context: any, payload: any){
      context.commit('setCustomer', payload)
    },
    setCustomers(context: any, payload: any){
      context.commit('setCustomers', payload)
    },
    addCustomer(context: any, payload: any){
      context.commit('addCustomer', payload)
    },
    resetCustomer(context: any){
      context.commit('resetCustomer')
    },
    setChangedPrice(context: any, payload:any)
    {
        context.commit('setChangedPrice', payload);
    },
    setAccessories(context: any, payload: any) {
        context.commit('setAccessories', payload)
    },
    deleteAccessories(context: any, payload: any) {
        context.commit('deleteAccessories', payload)
    },
    initFurtherInformationModule(context: any, payload: any) 
    {
        context.commit('initFurtherInformationModule', payload);
    },
    resetState(context: any){
        context.commit('resetState');
    }
}

const mutations = {
    setTextLineL(s: any, payload:any){
        s.TEXT_LINE_L = payload
    },
    setTextLineLD(s: any, payload:any){
        s.TEXT_LINE_LD = payload
    },
    setTextLineA(s: any, payload:any){
        s.TEXT_LINE_A = payload
    },
    setTextLineK(s: any, payload:any){
        s.TEXT_LINE_K = payload
    },
    setPurchNoC(s: any, payload: any) {
        s.PURCH_NO_C = payload
    },
    setChangedPrice(s:any, payload : any) {
        s.changedPrice = payload
    },
    setIncoterm(s: any, payload:any){
        s.incoterm = payload
    },
    setDeliveryAddress(s: any, payload:any){
        s.deliveryAddress = payload
    },
    setPaymentTerm(s: any, payload:any){
        s.paymentTerm = payload
    },
    setLand(s: any, payload: any){
      s.land = payload
    },
    setZone(s: any, payload: any){
      s.zone = payload
    },
    setFreight(s: any, payload: any){
      s.freight = payload
    },
    setCustomer(s: any, payload: any){
      s.customer = payload
    },
    setCustomers(s: any, payload: any){
      s.customers = payload
    },
    addCustomer(s: any, payload: any){
      s.customers.push(payload)
    },
    resetCustomer(s: any){
      s.customers = []
    },
    setAccessories(s: any, payload: any){
        s.accessories.push(payload)
    },
    deleteAccessories(s: any, payload: any){
        const accessoryIndex = s.accessories.findIndex((f: any) => f.id === payload.id);
        if (accessoryIndex !== -1){
            s.accessories.splice(accessoryIndex, 1)
        }
    },
    initFurtherInformationModule(s: any, payload: any){
        s.text = payload.text;
        s.incoterm = payload.incoterm;
        s.deliveryAddress = payload.deliveryAddress;
        s.paymentTerm = payload.paymentTerm
        s.TEXT_LINE_B = payload.TEXT_LINE_B
        s.TEXT_LINE_L = payload.TEXT_LINE_L
        s.TEXT_LINE_LD = payload.TEXT_LINE_LD
        s.TEXT_LINE_A = payload.TEXT_LINE_A
        s.TEXT_LINE_K = payload.TEXT_LINE_K
        s.PURCH_NO_C = payload.PURCH_NO_C
        s.land = payload.land
        s.zone = payload.zone
        s.freight = payload.freight
        s.customer = payload.customer
        s.accessories = payload.accessories
    },
    resetState(s: any)
    {
        Object.assign(s, getDefaultState());
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};